import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {scheduleIdleAnalytics} from '../utils/common-utils'

export default function usePdTagManager() {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {tagManager} = commerceAPI
    const {config} = tagManager || {}

    let googleTagManagerEnabled = false

    try {
        googleTagManagerEnabled = JSON.parse(config).gtmEnabled
    } catch (e) {
        console.log(e.message)
    }

    return {
        push(...args) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(...args)
        },
        pushIdle(...args) {
            scheduleIdleAnalytics(() => {
                this.push(...args)
            }, 0)
        },
        viewComponent(componentId, componentName, tilesCount) {
            if (!googleTagManagerEnabled) {
                return false
            }

            const event = {
                event: 'view_component',
                component_id: componentId,
                component_name: componentName || componentId
            }

            if (tilesCount) {
                event.tile_count = tilesCount
            }

            const pushEvent = () => {
                if (typeof window !== 'undefined') {
                    this.pushIdle(event)
                }
            }

            if (typeof window !== 'undefined' && window.__dataLayerLoaded) {
                // DataLayer already loaded, push immediately
                pushEvent()
            } else if (typeof window !== 'undefined') {
                // Wait for datalayer_loaded_event before pushing
                const handler = () => {
                    pushEvent()
                    window.removeEventListener('datalayer_loaded_event', handler)
                }
                window.addEventListener('datalayer_loaded_event', handler)
            }
        },
        selectComponent({
            componentId,
            componentName,
            titleName,
            titlePosition,
            linkUrl,
            imageUrl,
            subText,
            tileHeading,
            videoUrl
        }) {
            if (!googleTagManagerEnabled || !componentId) {
                return false
            }
            const event = {
                event: 'select_component',
                component_id: componentId,
                component_name: componentName || componentId
            }
            if (titleName) {
                event.tile_name = titleName
            }
            if (titlePosition !== undefined && titlePosition !== null) {
                event.tile_position = titlePosition + 1
            }
            if (linkUrl) {
                event.link_url = linkUrl
            }
            if (imageUrl) {
                event.image_url = imageUrl
            }
            if (subText) {
                event.tile_subtext = subText
            }
            if (tileHeading) {
                event.tile_heading = tileHeading
            }
            if (videoUrl) {
                event.video_url = videoUrl
            }
            this.push(event)
        }
    }
}
